<template>
    <div class="scale-graph-wrapper">

        <div class="main-data-wrapper">
            <div class="order-info">
                <div class="end-pallet-units">
                    <span>FIN DE PALET</span>
                    <div class="amount">
                        <span class="value">{{ dynamicData.endPalletUnits }}</span>
                        <span class="format">{{ dynamicData.format }}</span>
                    </div>
                </div>
                <div class="end-order-units">
                    <span>FIN DE PEDIDO</span>
                    <div class="amount">
                        <span class="value">{{ dynamicData.endOrderUnits }}</span>
                        <span class="format">{{ dynamicData.format }}</span>
                    </div>
                </div>
                <div class="actual-weight">
                    <span>PESO ACTUAL</span>
                    <div class="amount">
                        <span class="value">{{ actualWeight }}</span>
                        <span class="unit">{{ dynamicData.unit }}</span>
                    </div>
                </div>
            </div>
            <div class="actual-weight">
                <div class="state-hand">
                    <StateHand
                        :isOk="handIsOk"
                    />
                </div>
                <div class="scale">
                    <RadialGraph
                        :percentage="differencePercentage"
                        :weightDifference="actualWeightDifference"
                        :okMaxPercentage="okMaxPercentage"
                    />
                </div>
            </div>
        </div>
        <div class="right-data-wrapper">
            <div class="finished-units">
                <span class="value">{{ dynamicData.finishedUnits }}</span><br>
                <span class="format">{{ dynamicData.format }}</span><br>
                <span>FINALIZADAS</span>
            </div>
            <div class="total-ok-weight">
                <span>TOTAL OK</span>
                <div class="ok-hand">
                    <svg width="100px" height="100px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 71.01 71.01">
                        <g id="Capa_2" data-name="Capa 2">
                            <g id="Capa_1-2" data-name="Capa 1">
                                <g id="Thumb_Up" data-name="Thumb Up">
                                    <rect class="totalOk_cls-1" width="71.01" height="71.01" rx="35.51"/>
                                    <path id="thumb" class="totalOk_cls-2"
                                          d="M18.78,34.44V55.91a1.4,1.4,0,0,1-1.4,1.4H11.92a1.4,1.4,0,0,1-1.4-1.4V34.44a1.4,1.4,0,0,1,1.4-1.4h5.46A1.4,1.4,0,0,1,18.78,34.44ZM54.1,55.23c.48-1.42-.52-2.79.17-3.93.82-1.35,2.21-1.48,2.46-3.47.18-1.37-.8-2.49-.29-3.64.59-1.33,1.79-1.65,1.91-3.53.15-2.32-1.1-1.86,0-3.79a5.26,5.26,0,0,0,1.08-3.73c-1.13-6.31-12.4-3-16.49-3.26-4.68-.33-1-3.68.39-6.19a17,17,0,0,0,2.2-9C45.34,12,44.1,8.55,41.38,8.23c-4-.47-3.28,3.78-4.41,6.48C34.16,21.39,29.34,25,24.12,29.76c-2.1,1.9-3.79,3.62-3.79,6,0,4.36,0,10.7,0,14.85,0,4.58,1.51,5.72,6.32,6.11,6.41.52,12.85,2.1,19.28,2.1C48.86,58.84,53,58.63,54.1,55.23Z"/>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
                <div class="amount">
                    <span class="value">{{ dynamicData.totalOkWeight }}</span>
                    <span class="unit">{{ dynamicData.unit }}</span>
                </div>
            </div>
            <div class="total-nook-weight">
                <span>TOTAL NO OK</span>
                <div class="nook-hand">
                    <svg width="100px" height="100px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 73.99 73.99">
                        <g id="Capa_2" data-name="Capa 2">
                            <g id="Capa_1-2" data-name="Capa 1">
                                <g id="Thumb_Up" data-name="Thumb Up">
                                    <rect class="totalNook_cls-1" width="73.99" height="73.99" rx="37"/>
                                    <path id="thumb" class="totalNook_cls-2"
                                          d="M54.43,38.11V15.74a1.46,1.46,0,0,1,1.46-1.46h5.68A1.46,1.46,0,0,1,63,15.74V38.11a1.46,1.46,0,0,1-1.46,1.45H55.89A1.45,1.45,0,0,1,54.43,38.11ZM17.63,16.45c-.5,1.48.54,2.9-.18,4.1-.86,1.4-2.3,1.53-2.57,3.61-.18,1.42.84,2.59.3,3.79-.61,1.38-1.86,1.72-2,3.68-.16,2.41,1.14,1.94,0,3.95C12.44,36.8,11.75,38,12,39.46,13.2,46,25,42.57,29.21,42.86c4.87.34,1.09,3.83-.4,6.45a17.59,17.59,0,0,0-2.29,9.43c.23,2.72,1.52,6.35,4.36,6.68,4.13.49,3.41-3.94,4.6-6.76C38.4,51.71,43.42,47.9,48.86,43c2.19-2,4-3.77,4-6.28,0-4.55,0-11.15,0-15.47,0-4.77-1.57-6-6.58-6.37-6.68-.54-13.4-2.18-20.09-2.18C23.09,12.69,18.82,12.9,17.63,16.45Z"/>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
                <div class="amount">
                    <span class="value">{{ dynamicData.totalNookWeight }}</span>
                    <span class="unit">{{ dynamicData.unit }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import StateHand from "./StateHand";
import RadialGraph from "./RadialGraph";


import { mapGetters, mapActions } from 'vuex';
import axios from "axios";
import WebSocketUtils from '../../common/ws_utils';
import {showMessage, showWarning} from "../store/utils";

export default {
    name: "ScaleGraph",
    components:{
        StateHand,
        RadialGraph
    },
    props:{
        machineId:Number
    },
    data(){
        return{
            weightUpdateInterval : null,
            waitingResponse : false,
            handIsOk: true,
            differencePercentage: -100,
            actualWeight : 0,
            actualWeightDifference : 0,
            okMaxPercentage : 25,
            lastWeight: 0,
            wsSockets: []
        }
    },
    methods:{
        existsProperty(obj, propertyName){
            return obj.hasOwnProperty(propertyName) && obj[propertyName] != null;
        },
        roundNumber(number, numberOfDecimals){
            var aux = Math.pow(10, numberOfDecimals);
            return Math.round( number * aux) / aux;
        },
        beautifyNumber(number){
            return this.roundNumber(number, 2);
        },
        machineData(){
            return this.machine?
                (this.machine.hasOwnProperty('liveData')?
                    this.machine.liveData
                    : {})
                : {};
        },
        updateWeight(weight){
            this.lastWeight = this.actualWeight;
            this.actualWeight = weight;
            let machineData = this.activeMachineById(this.machineId)
            // En el grafico, el maximo y minimo validos seran un 25%, para que se vean los margenes en la zona verde

            this.okMaxPercentage = 25;

            this.actualWeightDifference = (weight - machineData.packaging_weight) - machineData.total_weight; //Negativo -> Falta para peso optimo | Positivo -> Sobra para peso optimo
            this.differencePercentage = Math.min(100, Math.max(-100,  ((this.actualWeightDifference / machineData.total_admissible_excess ) * 100) / (100/this.okMaxPercentage)   ))

            this.handIsOk = (Math.abs(Math.round(this.differencePercentage*100)/100) <= this.okMaxPercentage );
        },
        startWeightUpdates(){

            let kpiData = this.activeMachineById(this.machineId);

            if (!kpiData) return setTimeout( this.startWeightUpdates  , 1000)

            if( Utils.isString(kpiData.datalogger.web_socket_ip) ) this.startSocketListening(kpiData.datalogger.web_socket_ip, kpiData.machine.code);
            if( Utils.isString(kpiData.datalogger.local_web_socket_ip)) this.startSocketListening(kpiData.datalogger.local_web_socket_ip, kpiData.machine.code);

        },
        startSocketListening(webSocketIp, code){
            let self = this;
            var socket = WebSocketUtils.connect(webSocketIp)

            self.wsSockets.push({id:webSocketIp, socket: socket});

            socket.onopen = () => {
                showMessage(`Conectado a ${webSocketIp}`)
            }
            socket.onmessage =  ({ data }) => {
                const packet = JSON.parse(data);
                // console.log(packet)
                if(packet.machine_code == code && packet.net_weight != self.lastWeight)
                    self.updateWeight(packet.net_weight);
            };

            socket.onerror = (error) => {
                showWarning(`[ERROR]`, error)
            };
            socket.onclose = (error) => {
                showWarning(`[CLOSING WEBSOCKET LISTENER] IP: ${webSocketIp}`)
                self.wsSockets = self.wsSockets.filter(s => s.id != webSocketIp);
                // Al cerrarse, ya sea por haber pasado mucho tiempo o por algun error, vuelve a intentar conectarse 1 segndo despues
                setTimeout(() => { self.startSocketListening(webSocketIp, code) }, 1000);
            }
        }
    },
    mounted(){
        var self = this;
        self.waitingResponse = false;

        // Para probar los pesos desde el navegador

        // Primer peso, proveniente de los datos iniciales, los cambios que vengan luego en el pesaje seran a traves de MQTT
        this.updateWeight(this.activeMachineById(this.machineId).actual_weight);

        this.startWeightUpdates();

    },
    beforeDestroy() {
        clearInterval(this.weightUpdateInterval)
        this.wsSockets.forEach( s => {
            s.socket.close()
        })
    },
    computed:{
        ...mapGetters(['umaApiConf']),
        ...mapGetters('monitorization',['activeMachineById']),
        kpiData(){
            let activeMachineData = this.activeMachineById(this.machineId);
            let returnData = activeMachineData && activeMachineData.hasOwnProperty('kpi')? activeMachineData.kpi: null;
            returnData = {
                packaging: {
                    packaging_format: {
                        descrip: 'BOX'
                    }
                },
                palet_remaining_quantity: 10,
                total_remaining_quantity: 20,
                finished_quantity: 30,
                actualWeight: 50,
                total_ok_weight: 100,
                total_nok_weight: 20
            }
            return returnData;
        },
        dynamicData() {
            return {
                format:         this.kpiData.packaging?.packaging_format?.descrip ?? 'CAJA',
                unit:           'KG',
                endPalletUnits: Math.round(this.kpiData.palet_remaining_quantity)   ?? 0,
                endOrderUnits:  Math.round(this.kpiData.total_remaining_quantity)  ?? 0,
                finishedUnits:  Math.round(this.kpiData.finished_quantity) ??0,
                weight:         this.beautifyNumber(this.kpiData.actualWeight),
                difference:     0,
                totalOkWeight:  this.beautifyNumber(this.kpiData.total_ok_weight),
                totalNookWeight:this.beautifyNumber(this.kpiData.total_nok_weight)
            };
        }
    }
}
</script>

<style scoped>
/* OK Hand*/
.totalOk_cls-1 {
    fill: #7fb440;
}

.totalOk_cls-2 {
    fill: #f9f9f9;
}

/*No OK Hand */
.totalNook_cls-1 {
    fill: #cf1615;
}
.totalNook_cls-2 {
    fill: #fcfcfc;
}
</style>
